/* Thoson cart drawer: phone layout ("Propuesta A", Fares, 27 sep 2026).
   Loaded by sections/thx-cart-layout.liquid, which sits in the footer group.
   The styles live in assets/thx-cart-mobile.css, section 5.

   The theme re-renders the drawer markup on every cart change, so each step
   below is idempotent and runs again from a MutationObserver.
   On a phone (max-width 749px):
   1. the reservation timer moves into the header, next to the close button,
      which frees its own row in the list;
   2. each line's saving ("(You save $70)") moves next to the variant and
      reads "You Save $70" (Fares, 27 sep: a bare "Save $70" looked like a
      button people might tap). When the line has an automatic discount, its
      short name joins the same chip ("Duo Set", then "You Save $139") and
      the theme's discount badge is hidden, so a volume discount takes one
      row, not three. A line that shows a variant chip skips the discount
      name, so both chips still fit in one row;
   3. only one upsells container survives (a partial re-render can leave an
      old one in the list and a new one in the pinned footer) and it lives in
      the list. The header script moves it too; both moves are the same, so
      it does not matter which observer runs first. Since 14 oct 2026 the
      global block is the "Parents' Top Picks" list (.thx-picks, see
      snippets/thx-cart-picks.liquid), which already sits under the items on
      every width; when it is there, see placeUpsells below.
   Wider than that, the timer and the savings go back where the theme puts
   them. On every width the heading says "1 item", not "1 items".

   Also on every width: the "+ Add" buttons of the drawer upsells lose their
   name="add" (Fares, 27 sep: tapping one took the shopper to /cart). They
   sit outside their form (they point at it with form="..."), and on product
   pages the Zipify One Click Upsell script treats any name="add" button
   outside a form as a theme add button it has to rescue: it cancels the
   click, submits the FIRST /cart/add form of the page for real (the Bot
   upsell, whatever was tapped) and Shopify answers with the cart page.
   Without the name, the theme's product-form adds the right product by
   ajax and the drawer stays open. The theme never reads that name on these
   buttons. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var ZEROS = /(\d)\.00(?!\d)/g;

  function fixHeading(root) {
    var heading = root.querySelector('.drawer__heading');
    if (!heading) return;
    for (var node = heading.firstChild; node; node = node.nextSibling) {
      if (node.nodeType === 3 && /\b1 items\b/.test(node.data)) {
        node.data = node.data.replace(/\b1 items\b/, '1 item');
      }
    }
  }

  function placeTimer(root, phone) {
    var timer = root.querySelector('.cart-timer');
    var head = root.querySelector('.drawer__header');
    var body = root.querySelector('.cart-drawer__body');
    if (!timer || !head || !body) return;
    if (phone) {
      if (timer.parentElement !== head) {
        var close = head.querySelector('.drawer__close');
        head.insertBefore(timer, close && close.parentElement === head ? close : null);
        timer.classList.add('thx-timer-in-head');
      }
    } else if (timer.parentElement === head) {
      body.insertBefore(timer, body.firstChild);
      timer.classList.remove('thx-timer-in-head');
    }
  }

  /* "Duo Set Limited Time" -> "Duo Set". Empty when the discount is named
     after the product itself ("Bot Limited Time" on Thoson Bot), because the
     line title already says it. */
  function dealName(row) {
    var badge = row.querySelector('.cart-drawer__discounts .badge');
    if (!badge) return '';
    var span = badge.querySelector('span') || badge;
    var name = span.textContent.replace(/\s+/g, ' ').trim()
      .replace(/[\s:|-]*limited[\s-]*time\b.*$/i, '').trim();
    var title = row.querySelector('.cart-item__name');
    if (!name) return '';
    if (title && title.textContent.toLowerCase().indexOf(name.toLowerCase()) !== -1) return '';
    return name;
  }

  function chipPart(className, text) {
    var part = document.createElement('span');
    part.className = className;
    part.textContent = text;
    return part;
  }

  function placeSavings(root, phone) {
    var rows = root.querySelectorAll('.cart-drawer-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var saving = row.querySelector('.cart-drawer-item__saving');
      var details = row.querySelector('.cart-item__details');
      if (!saving || !details) continue;
      var label = saving.querySelector('strong') || saving;
      var discounts = row.querySelector('.cart-drawer__discounts');
      if (!saving.hasAttribute('data-thx-text')) {
        saving.setAttribute('data-thx-text', label.textContent.trim());
      }
      var original = saving.getAttribute('data-thx-text');
      if (phone) {
        var options = details.querySelector('dl');
        if (saving.parentElement !== details) {
          details.insertBefore(saving, options ? options.nextSibling : null);
          saving.classList.add('thx-saving-chip');
        }
        var match = original.match(/save\s+(.+?)\)?$/i);
        var text = match ? 'You Save ' + match[1].replace(ZEROS, '$1') : original;
        var hasVariant = !!(options && options.textContent.replace(/\s+/g, '').length);
        var deal = hasVariant ? '' : dealName(row);
        var shown = deal + '|' + text;
        if (saving.getAttribute('data-thx-shown') !== shown) {
          saving.setAttribute('data-thx-shown', shown);
          label.textContent = '';
          if (deal) label.appendChild(chipPart('thx-chip-deal', deal));
          label.appendChild(chipPart('thx-chip-save', text));
        }
        if (discounts && !discounts.classList.contains('thx-deal-in-chip')) {
          discounts.classList.add('thx-deal-in-chip');
        }
      } else {
        if (saving.parentElement === details) {
          var home = row.querySelector('.cart-item__totals .cart-item__price-wrapper');
          if (!home) continue;
          home.appendChild(saving);
          saving.classList.remove('thx-saving-chip');
        }
        if (saving.hasAttribute('data-thx-shown')) {
          saving.removeAttribute('data-thx-shown');
          label.textContent = original;
        }
        if (discounts && discounts.classList.contains('thx-deal-in-chip')) {
          discounts.classList.remove('thx-deal-in-chip');
        }
      }
    }
  }

  /* With the "Parents' Top Picks" list on the page (.thx-picks, Fares,
     14 oct 2026), the only containers left with the theme class are the
     per product toggles (Bot markers, MagTrack train, Magic Art refills).
     They have been off since this script arrived (Propuesta A, 27 sep
     2026): the rule below keeps one container and that was always the
     global one. They stay off, so the cart is the one Fares approved.
     Without the list, nothing changes. */
  function placeUpsells(root, phone) {
    var all = root.querySelectorAll('.cart-drawer-upsells-container');
    if (!all.length) return;
    if (root.querySelector('.thx-picks')) {
      for (var j = 0; j < all.length; j++) all[j].parentElement.removeChild(all[j]);
      return;
    }
    var body = root.querySelector('.cart-drawer__body');
    var foot = root.querySelector('.drawer__footer');
    if (all.length > 1) {
      var keep = (foot && foot.querySelector('.cart-drawer-upsells-container')) || all[all.length - 1];
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== keep) all[i].parentElement.removeChild(all[i]);
      }
    }
    var ups = root.querySelector('.cart-drawer-upsells-container');
    if (phone && body && ups && ups.parentElement !== body) {
      body.appendChild(ups);
      ups.classList.add('thx-ups-in-body');
    }
  }

  function unnameAddButtons(root) {
    var buttons = root.querySelectorAll('button[name="add"]');
    for (var i = 0; i < buttons.length; i++) {
      if (!buttons[i].closest('form[action$="/cart/add"]')) buttons[i].removeAttribute('name');
    }
  }

  function run() {
    var root = document.querySelector('cart-drawer');
    if (!root) return;
    var phone = MOBILE.matches;
    unnameAddButtons(root);
    fixHeading(root);
    placeTimer(root, phone);
    placeSavings(root, phone);
    placeUpsells(root, phone);
  }

  function start() {
    var root = document.querySelector('cart-drawer');
    if (!root) return;
    run();
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }
    /* the countdown rewrites its digits every second: ignore those */
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var target = list[i].target;
        var el = target.nodeType === 1 ? target : target.parentElement;
        if (!el || !el.closest || !el.closest('countdown-timer')) { schedule(); return; }
      }
    }).observe(root, { childList: true, subtree: true });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', run);
    else if (MOBILE.addListener) MOBILE.addListener(run);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();